import styled from 'styled-components';

export const Button = styled.button`
  position: fixed;
  cursor: pointer;
  background-color: #50c878;
  color: white;
  padding: 10px;
  z-index: 9999;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;
